export default __webpack_public_path__ + "static/media/c44bbc7b4ca41666306ec009af3906cc.svg";